document.addEventListener( 'DOMContentLoaded', function() {
	'use strict';

	const body = document.body;

	const withJq = function( cb ) {
		if ( typeof window.jQuery === 'function' ) {
			cb( window.jQuery );
		}
	};

	const listenerRegistry = new WeakMap();

	const normalizePayload = function( detail ) {
		if ( !detail ) {
			return detail;
		}
		let payload = detail;
		withJq( function( $ ) {
			if ( detail instanceof Element ) {
				payload = $( detail );
			}
		} );
		return payload;
	};

	const addColibriListener = function( target, eventName, handler, options = {} ) {
		const nativeHandler = function( event ) {
			handler( event, event?.detail );
		};
		target.addEventListener( eventName, nativeHandler, options );

		let jqHandler = null;
		withJq( function( $ ) {
			jqHandler = function( event, data ) {
				handler( event, data ?? event?.originalEvent?.detail );
			};
			$( target ).on( eventName, jqHandler );
		} );

		if ( !listenerRegistry.has( target ) ) {
			listenerRegistry.set( target, [] );
		}
		listenerRegistry.get( target ).push( {
			eventName,
			handler,
			nativeHandler,
			jqHandler,
			options,
		} );
	};

	const removeColibriListener = function( target, eventName, handler ) {
		const listeners = listenerRegistry.get( target );
		if ( !listeners || !listeners.length ) {
			return;
		}

		for ( let i = listeners.length - 1; i >= 0; i-- ) {
			const item = listeners[ i ];
			if ( item.eventName !== eventName || item.handler !== handler ) {
				continue;
			}
			target.removeEventListener( eventName, item.nativeHandler, item.options );
			withJq( function( $ ) {
				if ( item.jqHandler ) {
					$( target ).off( eventName, item.jqHandler );
				}
			} );
			listeners.splice( i, 1 );
		}
	};

	const emitColibriEvent = function( target, eventName, detail, useTriggerHandler = false ) {
		const customEvent = new CustomEvent( eventName, { detail } );
		target.dispatchEvent( customEvent );
		withJq( function( $ ) {
			const payload = normalizePayload( detail );
			if ( useTriggerHandler ) {
				$( target ).triggerHandler( eventName, [ payload ] );
				return;
			}
			$( target ).trigger( eventName, [ payload ] );
		} );
	};

	addColibriListener( body, 'ColibriEvent:AFTER_MODAL_UPDATED', function() {
		// Marketing API product preview + `window.colibri.upsell` own quick-view upsell.
		if ( window.colibri && window.colibri.upsell ) {
			return;
		}

		const upsellBlock = document.querySelector( '.modal--quick-view .upsell-block' );
		if ( ! upsellBlock ) {
			return;
		}

		upsellBlock.innerHTML = `
			<p class="upsell-block__text">This course is <b>FREE with Membership!</b></p>
			<h4 class="upsell-block__name"></h4>
			<div class="upsell-block__pricing">
				<div class="price">
					<span class="price-icon">$</span>
					<span class="price-amount"></span>
					<span class="price-period"></span>
				</div>
			</div>
			<div class="btn-wrapper"></div>
		`;

		const sourceAddToCart = document.querySelector( '.modal--quick-view .product-actions .add-to-cart-container' );
		const btnWrapper = upsellBlock.querySelector( '.btn-wrapper' );
		if ( ! sourceAddToCart || ! btnWrapper ) {
			return;
		}

		const upsellAddToCart = sourceAddToCart.cloneNode( true );
		upsellAddToCart.removeAttribute( 'data-product-code' );
		upsellAddToCart.removeAttribute( 'data-alt-product-code' );
		upsellAddToCart.removeAttribute( 'data-partnership-group-item-id' );
		btnWrapper.appendChild( upsellAddToCart );
	} );

	addColibriListener( body, 'ColibriEvent:AFTER_STATUS_CHECK', function( _event, data ) {
		const upsellBlock = document.querySelector( '.modal--quick-view .upsell-block' );
		const upsellCartContainer = upsellBlock?.querySelector( '.add-to-cart-container' );

		if ( ! upsellBlock || ! upsellCartContainer ) {
			return;
		}

		if ( ! ( data && Array.isArray( data.response ) && data.response.length > 0 && data.response[ 0 ]?.Properties ) ) {
			return;
		}

		const response = data.response[ 0 ];
		const upsellMembershipProductCode = response.Properties?.UpsellMembershipProductCode;
		if ( upsellMembershipProductCode && upsellCartContainer.getAttribute( 'data-product-code' ) === upsellMembershipProductCode ) {
			return;
		}

		if ( ! upsellMembershipProductCode ) {
			upsellBlock.classList.add( 'hide' );
			return;
		}

		if ( upsellCartContainer.getAttribute( 'data-product-code' ) ) {
			emitColibriEvent( body, 'ColibriEvent:UNINDEX_ADD_TO_CART', upsellCartContainer );
		}

		if ( data?.add_to_cart_requested && data.add_to_cart_requested.indexOf( upsellMembershipProductCode ) !== -1 ) {
			upsellCartContainer.querySelector( '.add-to-cart' )?.classList.add( 'hidden' );
			upsellCartContainer.querySelector( '.checkout' )?.classList.remove( 'hidden' );
		}

		const upsellMembershipName = response.Properties?.UpsellMembershipName;
		const upsellMembershipPrice = response.Properties?.UpsellMembershipPrice ?? '0';
		const upsellMembershipMonths = response.Properties?.UpsellMembershipMonths;
		const upsellMembershipPriceFormatted = parseInt( String( upsellMembershipPrice ).replace( /,/g, '' ), 10 ) || 0;
		const upsellMembershipPriceAffirm = upsellMembershipPriceFormatted * 100;
		const inMembership = response.Properties?.InMembership;
		let upsellPricePeriod = '';

		let affirmMessage = '';
		if (
			typeof window.colibri !== 'undefined'
			&& typeof window.colibri.affirmPriceThreshold !== 'undefined'
			&& window.colibri.affirmPriceThreshold <= upsellMembershipPriceFormatted
		) {
			affirmMessage = `<div class="affirm-as-low-as" data-page-type="product" data-amount="${upsellMembershipPriceAffirm}"></div>`;
		}

		upsellCartContainer.setAttribute( 'data-product-code', upsellMembershipProductCode );
		emitColibriEvent( window, 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', upsellBlock, true );

		if ( ! inMembership && upsellMembershipProductCode && upsellMembershipName && upsellMembershipPrice ) {
			upsellCartContainer.setAttribute( 'data-immediate-checkout', '1' );
			const nameEl = upsellBlock.querySelector( '.upsell-block__name' );
			const amountEl = upsellBlock.querySelector( '.price-amount' );
			const pricingEl = upsellBlock.querySelector( '.upsell-block__pricing' );
			if ( nameEl ) {
				nameEl.textContent = upsellMembershipName;
			}
			if ( amountEl ) {
				amountEl.textContent = upsellMembershipPrice;
			}

			if ( pricingEl && affirmMessage && ! upsellBlock.querySelector( '.affirm-as-low-as' ) ) {
				pricingEl.insertAdjacentHTML( 'afterend', affirmMessage );
			}

			const ajaxUrl = window.colibri?.admin_ajax;
			if ( ! ajaxUrl ) {
				upsellBlock.classList.add( 'hide' );
				return;
			}

			const url = new URL( ajaxUrl, window.location.origin );
			url.searchParams.set( 'action', 'get_upsell_discount' );
			url.searchParams.set( 'productCode', upsellMembershipProductCode );

			fetch( url.toString(), { method: 'GET' } )
				.then( function( r ) {
					if ( ! r.ok ) {
						throw new Error( `HTTP ${r.status}` );
					}
					return r.json();
				} )
				.then( function( ajaxResponse ) {
					const discountResponse = ajaxResponse?.data;
					const pricingNode = upsellBlock.querySelector( '.upsell-block__pricing' );

					if ( discountResponse?.discounted_price && pricingNode ) {
						const priceFormatted = discountResponse.discounted_price * 100;
						let discountedPrice = discountResponse.discounted_price.toString();
						if ( discountedPrice.indexOf( '.' ) !== -1 ) {
							const parts = discountedPrice.split( '.' );
							if ( parts[ 1 ].length === 1 ) {
								discountedPrice += '0';
							}
						}

						const discountedPriceNode = upsellBlock.querySelector( '.discounted-price' );
						const discountedMarkup = `
							<span class="price-icon">$</span>
							<span class="price-amount">${discountedPrice}</span>
							<span class="price-period">${upsellPricePeriod}</span>
						`;
						if ( ! discountedPriceNode ) {
							pricingNode.insertAdjacentHTML( 'afterbegin', `<div class="discounted-price">${discountedMarkup}</div>` );
						} else {
							discountedPriceNode.innerHTML = discountedMarkup;
						}

						const affirmNode = upsellBlock.querySelector( '.affirm-as-low-as' );
						if ( affirmNode ) {
							affirmNode.setAttribute( 'data-amount', String( priceFormatted ) );
						}

						const displayText = discountResponse.promo_rate_text?.trim() ? 'off with code:' : 'With Promo Code:';
						const discountInfoNode = upsellBlock.querySelector( '.discount-info' );
						const discountMarkup = `
							<span class="promo-rate">${discountResponse.promo_rate_text ?? ''}</span>
							<span class="text-to-display">${displayText}</span>
							<span class="promo-code-text">${discountResponse.promo_code_text ?? ''}</span>
						`;
						if ( ! discountInfoNode ) {
							pricingNode.insertAdjacentHTML( 'beforeend', `<div class="discount-info">${discountMarkup}</div>` );
						} else {
							discountInfoNode.innerHTML = discountMarkup;
						}
					}

					upsellCartContainer.setAttribute( 'data-payment-option-id', String( discountResponse?.payment_option_id ?? 0 ) );
					upsellBlock.classList.remove( 'hide' );

					if ( discountResponse?.payment_option_id === 0 ) {
						upsellPricePeriod = '';
					} else if ( upsellMembershipMonths === '12' ) {
						upsellPricePeriod = '/year';
					} else if ( upsellMembershipMonths === '24' ) {
						upsellPricePeriod = '/2 years';
					}

					const periodEl = upsellBlock.querySelector( '.price-period' );
					if ( periodEl ) {
						periodEl.textContent = upsellPricePeriod;
					}
				} )
				.catch( function( error ) {
					console.log( 'response error: ', error );
					upsellBlock.classList.add( 'hide' );
				} );
		}

		window.affirm?.ui?.ready?.( () => window.affirm.ui.refresh?.() );
	} );

	const onAddToCartSuccess = function() {
		const target = document.querySelector( '.modal--quick-view' );
		if ( ! target || ! target.querySelector( '.upsell-block' ) ) {
			return;
		}
		target.querySelector( '.product-actions .add-to-cart button' )?.click();

		removeColibriListener( body, 'ColibriEvent:DO_ADD_TO_CART_SUCCESS', onAddToCartSuccess );
	};

	addColibriListener( body, 'ColibriEvent:DO_ADD_TO_CART_SUCCESS', onAddToCartSuccess );
} );
